import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enTranslation from "./locale/en/translation.json";
import jaTranslation from "./locale/ja/translation.json";

const resources = {
  en: { translation: enTranslation },
  ja: { translation: jaTranslation },
};

export const initializeI18n = (language = "en") => {
  i18n
    .use(initReactI18next)
    .init({
      resources,
      lng: language,
      fallbackLng: "en",
      interpolation: {
        escapeValue: false,
      },
    });
};

// Initialize with default or stored language
initializeI18n(localStorage.getItem("language") || "en");

export default i18n;